import { useNavigate } from "react-router-dom";
import { LogoMark } from "@/components/Logo";
import { scrollToId, FIRM } from "@/lib/site";
import { useLang } from "@/lib/lang";

export default function Footer() {
  const navigate = useNavigate();
  const { t } = useLang();

  const LINKS = [
    { id: "studio", label: t.nav.studio },
    { id: "aree", label: t.nav.aree },
    { id: "team", label: t.nav.team },
    { id: "sede", label: t.nav.sede },
    { id: "metodo", label: t.nav.metodo },
    { id: "news", label: t.nav.news },
    { id: "contatti", label: t.nav.contatti },
  ];

  return (
    <footer data-testid="footer-section" className="bg-navy-ink pb-10 pt-20 text-alabaster">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-12 border-b border-alabaster/10 pb-14 md:grid-cols-3">
          <div>
            <LogoMark className="h-14" />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-alabaster/50">{t.footer.about}</p>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">{t.footer.nav}</p>
            <ul className="mt-5 space-y-3">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollToId(l.id)}
                    className="link-gold text-sm text-alabaster/70 transition-colors hover:text-alabaster"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">{t.footer.contatti}</p>
            <ul className="mt-5 space-y-3 text-sm text-alabaster/70">
              <li>{FIRM.address}</li>
              <li>
                <a data-testid="footer-phone" href={`tel:${FIRM.phoneHref}`} className="transition-colors hover:text-gold">
                  {FIRM.phone}
                </a>
              </li>
              <li>
                <a data-testid="footer-whatsapp" href={FIRM.whatsappHref} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-gold">
                  WhatsApp {FIRM.whatsapp}
                </a>
              </li>
              <li>{FIRM.email}</li>
              <li>PEC: {FIRM.pec}</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-4 pt-8 md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-legal-notice" className="max-w-xl text-[11px] leading-relaxed text-alabaster/40">
            © {new Date().getFullYear()} {FIRM.name} · P.IVA 03451670735. {t.footer.legal}
          </p>
          <div className="flex items-center gap-6">
            <button
              data-testid="footer-privacy-link"
              onClick={() => navigate("/privacy")}
              className="link-gold w-max font-mono text-[10px] uppercase tracking-[0.2em] text-alabaster/50 hover:text-alabaster"
            >
              {t.footer.privacy}
            </button>
            <button
              data-testid="footer-admin-link"
              onClick={() => navigate("/admin")}
              className="link-gold w-max font-mono text-[10px] uppercase tracking-[0.2em] text-alabaster/50 hover:text-alabaster"
            >
              {t.footer.admin}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
